module.exports = __webpack_public_path__ + "img/Paypal.9a9baf48.png";